import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const LogoutProvider = ({ children, userManager, securityStamp }) => {
  useEffect(() => {
    if (!securityStamp) return;
    console.log(
      `Identity server security stamp changed to ${securityStamp} for this user. Probably the user logged in on another device. Logging out`
    );

    userManager.signoutRedirect();
  }, [securityStamp, userManager]);

  return <>{children}</>;
};

LogoutProvider.propTypes = {
  children: PropTypes.node,
  userManager: PropTypes.object.isRequired,
  securityStamp: PropTypes.string
};

const mapStateToProps = state => ({
  securityStamp: state.userInfo?.newSecurityStamp
});

export default connect(mapStateToProps)(LogoutProvider);
